import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import {
  ConsultarCampanasNuevoRequest,
  ConsultarCampanasNuevoParams
} from '../../models/cotizador-contratante/consultar-campanas-nuevo/request/consultar-campanas-nuevo-request.model';
import { ConsultarCampanasNuevoResponse } from '../../models/cotizador-contratante/consultar-campanas-nuevo/response/consultar-campanas-nuevo-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarCampanasNuevoService {
  private readonly url = `${environment.HOST}${URL_MAP.API.CONSULTAR_CAMPANAS_NUEVAS}`;

  constructor(private http: HttpClient) {}

  consultarCampanas(params: ConsultarCampanasNuevoParams): Observable<ConsultarCampanasNuevoResponse> {
    const body: ConsultarCampanasNuevoRequest = {
      nombreClave: 'getCampaniaCtz',
      jsonParametros: JSON.stringify({
        nu_pagina: params.nu_pagina ?? '1',
        nu_tamanoPagina: params.nu_tamanoPagina ?? '1000',
        vc_codigoCampana: params.vc_codigoCampana ?? '',
        vc_nombreComercial: params.vc_nombreComercial ?? '',
        vc_lineaNegocio: params.vc_lineaNegocio ?? '',
        vc_cuenta: params.vc_cuenta ?? '',
        vc_subcuenta: params.vc_subcuenta ?? '',
        vc_grupoPrograma: params.vc_grupoPrograma ?? '',
        vc_programa: params.vc_programa ?? '',
        vc_tipoPlan: params.vc_tipoPlan ?? '',
        fe_inicioVig: params.fe_inicioVig ?? '',
        fe_finVig: params.fe_finVig ?? '',
        nu_acumulable: params.nu_acumulable ?? '',
        nu_debitoAuto: params.nu_debitoAuto ?? '',
        nu_prontoPago: params.nu_prontoPago ?? '',
        vc_genero: params.vc_genero ?? '',
        vc_edad: params.vc_edad ?? '',
        vc_parentesco: params.vc_parentesco ?? '',
        vc_cod_tarifa: params.vc_cod_tarifa || ''
      })
    };

    return this.http.post<ConsultarCampanasNuevoResponse>(this.url, body).pipe(
      catchError(err => {
        console.error('Error en consultarCampanas:', err);
        return throwError(() => new Error(err?.message || 'Error al consultar campanas'));
      })
    );
  }
}
